import { DataV2API } from "../Endpoints";

class Tabs {
    getPharmacyTabs() {
        return DataV2API.get("/tabs");
    }

    addPharmacyTab(tab) {
        return DataV2API.post("/tabs", tab);
    }

    changeCustomPharmacyTabOrder(tabOrder) {
        return DataV2API.post("/tabs/order", tabOrder);
    }

    changePharmacyTab(tab) {
        return DataV2API.post("/tab/" + tab.id, tab);
    }

    deletePharmacyTab(tab) {
        return DataV2API.delete("/tab/" + tab.id, {});
    }
}
export default new Tabs();
